import type { CSSProperties } from 'vue';

export const PREVIEW_STRIPE = { base: 'transparent', stripe: '#f5d793', border: '#fbc531' };
export const AFFECTED_STRIPE = { base: 'transparent', stripe: '#f7802a', border: '#f4a142' };

export const VIOLATION_CATEGORIES = ['violation.category_law', 'violation.category_soft_law', 'violation.category_custom', 'violation.category_operations'];

export const extractId = (v: any): string | null => {
	if (v == null) {
		return null;
	}
	if (typeof v === 'object') {
		return extractId(v.id ?? v._id ?? v.uuid);
	}
	return String(v);
};

export const stripes = (base: string, stripe: string, size = 2): string => {
	return `repeating-linear-gradient(135deg, ${base} 0 ${size}px, ${stripe} ${size}px ${size * 2}px)`;
};

export const getDutyStripe = (duty: any): typeof PREVIEW_STRIPE | undefined => {
	if (!duty || duty.deleted) {
		return undefined;
	}

	let stripe: typeof PREVIEW_STRIPE | undefined;

	if (duty.preview && (duty.original || duty.uuid)) {
		stripe = PREVIEW_STRIPE;
	}

	if (duty.affectedByAnyPreview) {
		stripe = AFFECTED_STRIPE;
	}

	return stripe;
};

export const getDutyCellStyle = (duty: any): CSSProperties => {
	const stripe = getDutyStripe(duty);
	if (!stripe) {
		return {};
	}

	return {
		backgroundImage: stripes(stripe.base, stripe.stripe),
	};
};

export interface DayItem {
	data: any;
	id: string | null;
	isoDate: string;
	weekendClass?: string;
	isMonthBoundary?: boolean;
	weekdayLabel?: string;
	dayNum?: string;
	statusClass?: string;
	dayClass?: Record<string, boolean>;
	isHidden: boolean;
}
